import client from "@/api/client";
import { MembershipApiClient } from "../../../cbi-generator/frontend/api/MembershipApiClient";
import { MembershipFrontendService } from "../../../cbi-generator/frontend/services/MembershipFrontendService";
import type { MembershipTypeMember } from "../../../cbi-generator/generated/dto/MembershipTypeMember";

/**
 * Membership types a member can buy online for one program (PROGRAM_TYPES.PROGRAM_ID). The
 * server already filters to active/available-online and sorts by display order.
 */
export function useMembershipPurchaseOptions(programId: number) {
  const membershipTypes = ref<MembershipTypeMember[]>();
  new MembershipFrontendService(new MembershipApiClient(client))
    .purchaseOptionsPublic()
    .then((all) => {
      membershipTypes.value = all.filter(
        (type) => type.programIdTargetIds?.programId === programId,
      );
    })
    .catch(() => {
      membershipTypes.value = [];
    });
  return membershipTypes;
}
